import queryString from 'query-string'
import { request } from 'shared/helpers/sagas'
import { axiosInstance } from 'network/apis';
import axios from "axios";


export const getProjectsRequest = async (payload) => {
  payload.id = 1
  console.log("payload ", payload)

return await axiosInstance.post(`project/get-projects/client/${payload.clientId}`, {}, { handlerEnabled: true })

};

export const getProjectsForModeratorRequest = async (payload) => {
  payload.id = 1
  console.log("payload in getProjectsForModeratorRequest ", payload)

return await axiosInstance.get(`moderator/get-projects/${payload.moderatorId}/client/${payload.clientId}`, { handlerEnabled: true })

};

export const getProjectsList = async (payload, queryParams, filteredClients) => {
  console.log("payload in getProjectsList ", payload)
  let filteredClientsList = ''
  if(filteredClients.length === 0) filteredClientsList = "('')"
  else filteredClientsList = `(${filteredClients.map(c => `'${c}'`).join(',')})`
  return await axiosInstance.post(`project/get-projects/client/${payload.clientId}${queryParams? queryParams: '' }`, {externalClientsIds: filteredClientsList, projectAccountId: payload.projectAccountId.toString(), userId: payload.userId} , { handlerEnabled: true })
}

export default {
  getProjectsRequest,
  getProjectsForModeratorRequest,
  getProjectsList
}